<template>
	<transition name="fade">
		<span class="back-to-top" v-show="showBackToTop" @click.prevent="backToTop">
   			<slot></slot>
 		</span>
 	</transition>
</template>

<script>
	import ScrollPosition from '../mixins/scroll-position';
	import vueScrollTo from 'vue-scrollTo';

	export default {
		mixins: [ScrollPosition],

		props: {
			duration: {
				type: Number,
				default: 500
			},

			targetId: {
				required: true,
				type: String
			},

			tolerance: {
				type: Number,
				default: 500
			}
		},

		computed: {
			showBackToTop() {
				return this.scrollPosition > this.tolerance;
			}
		},

		methods: {
			backToTop() {
				$('.back-to-top').children().blur();

				vueScrollTo.scrollTo('#'+this.targetId, this.duration, {
				    easing: vueScrollTo.easing['ease-in'],
		    		offset: 0
				});
			}
		}
	}
</script>
